/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Warnings_HintInputs */

const en_views_warnings_hint = /** @type {(inputs: Views_Warnings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The view saves anyway; these parts of the filter match nothing yet.`)
};

const de_views_warnings_hint = /** @type {(inputs: Views_Warnings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ansicht wird trotzdem gespeichert; diese Teile des Filters treffen noch nichts.`)
};

/**
* | output |
* | --- |
* | "The view saves anyway; these parts of the filter match nothing yet." |
*
* @param {Views_Warnings_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_warnings_hint = /** @type {((inputs?: Views_Warnings_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Warnings_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_warnings_hint(inputs)
	return en_views_warnings_hint(inputs)
});